import { render, staticRenderFns } from "./userRegister.vue?vue&type=template&id=8c0ddfaa&scoped=true"
import script from "./userRegister.vue?vue&type=script&lang=js"
export * from "./userRegister.vue?vue&type=script&lang=js"
import style0 from "./userRegister.vue?vue&type=style&index=0&id=8c0ddfaa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0ddfaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c0ddfaa')) {
      api.createRecord('8c0ddfaa', component.options)
    } else {
      api.reload('8c0ddfaa', component.options)
    }
    module.hot.accept("./userRegister.vue?vue&type=template&id=8c0ddfaa&scoped=true", function () {
      api.rerender('8c0ddfaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/login/userRegister.vue"
export default component.exports